import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth";
import { RequireAdmin } from "./components/RequireAdmin";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { LanguagesPage } from "./pages/LanguagesPage";
import { LoginPage } from "./pages/LoginPage";
import { OverviewPage } from "./pages/OverviewPage";
import { PublishPage } from "./pages/PublishPage";
import { ReadingDayPage } from "./pages/ReadingDayPage";
import { ReadingsCalendarPage } from "./pages/ReadingsCalendarPage";
import { SchemaPage } from "./pages/SchemaPage";
import { ScrapePage } from "./pages/ScrapePage";
import { SettingsPage } from "./pages/SettingsPage";
import { SyncPage } from "./pages/SyncPage";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route element={<RequireAdmin />}>
            <Route path="/" element={<OverviewPage />} />
            <Route path="/readings" element={<ReadingsCalendarPage />} />
            <Route path="/readings/:dateKey" element={<ReadingDayPage />} />
            <Route path="/scrape" element={<ScrapePage />} />
            <Route path="/publish" element={<PublishPage />} />
            <Route path="/sync" element={<SyncPage />} />
            <Route path="/languages" element={<LanguagesPage />} />
            <Route path="/schema" element={<SchemaPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
